import request from './request';

const orders = {
	async getOrderByOrderId(query) {
		const res = await request.get('/app/orders/order-id', query);
		return res;
	},

	async createOrder(body) {
		const res = await request.post('/app/orders', body);
		return res;
	},

	async verifyPaymentCallback(query) {
		const res = await request.get('/app/orders/callback', query);
		return res;
	}
};

export default orders;
